// The Banger Halloween pack (store/packages/threedom/halloween-*, docs/build/haunt.md): the tiles the hub links to the
// store, and the art the zone uses. Every package passes `store build` + `check --render`.

export const SHOWCASE = "/store/packages/threedom/halloween-src/showcase";

export interface PackItem {
  /** store package id */
  id: string;
  title: string;
  line: string;
  /** an avatar cosmetic (worn), not a prop */
  wear?: boolean;
}

export const PACK: PackItem[] = [
  { id: "threedom/halloween-pumpkin", title: "Jack-o'-Lantern", line: "Carve the face: classic, happy, scary or surprised." },
  { id: "threedom/halloween-gravestone", title: "Gravestone", line: "Five shapes, weathered and leaning." },
  { id: "threedom/halloween-dead-tree", title: "Dead Tree", line: "Bare branches, grown from a seed." },
  { id: "threedom/halloween-house-kit", title: "Haunted House Kit", line: "A whole house or its pieces, one to three floors." },
  { id: "threedom/halloween-fence", title: "Graveyard Fence", line: "Iron or picket, any length." },
  { id: "threedom/halloween-candles", title: "Melted Candles", line: "Flickering flames." },
  { id: "threedom/halloween-lantern", title: "Flicker Lantern", line: "A lantern with a real light inside." },
  { id: "threedom/halloween-fog", title: "Ground Fog", line: "Low, drifting mist." },
  { id: "threedom/halloween-bats", title: "Bat Swarm", line: "A flock that circles overhead." },
  { id: "threedom/halloween-ghost", title: "Sheet Ghost", line: "Floats. Says boo." },
  { id: "threedom/halloween-pumpkin-head", title: "Pumpkin Head", line: "Free for every avatar.", wear: true },
  { id: "threedom/halloween-pumpkin-head-lit", title: "Candlelit Pumpkin Head", line: "Lit from inside. Earn it in Open Haunt.", wear: true },
  { id: "threedom/halloween-witch-hat", title: "Witch Hat", line: "Tall, crooked, yours.", wear: true },
  { id: "threedom/halloween-skeleton-hoodie", title: "Skeleton Hoodie", line: "Bones on the outside.", wear: true },
];

export const assetHref = (id: string) => `/store/a/${id}`;
export const previewSrc = (id: string) => `/store/packages/${id}/preview.png`;

/** The hero's posters: frames of the live scene (shown first, and kept on reduced motion and low-power phones). */
export const HERO_POSTER = `${SHOWCASE}/open-haunt-hero-wide.jpg`;
export const HERO_POSTER_TALL = `${SHOWCASE}/open-haunt-hero-tall.jpg`;
export const NIGHT_ART = `${SHOWCASE}/house.jpg`;
export const TEMPLATE_ART = `${SHOWCASE}/template-gate.jpg`;
